import {mapMutations} from "vuex";
export default {
  methods: {
    ...mapMutations({
      loadOn: 'loader/startLoading',
      loadOff: "loader/stopLoading",
    }),
    pageLoading(action) {
      if (action) {
        this.loadOn()
      } else
        this.loadOff()
    },
  }
}
